import React from "react";
import { Check, Loader2 } from "lucide-react";

export default function SaveIndicator({ status }) {
  if (status === "saving") {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
        <Loader2 size={12} className="animate-spin" />
        Saving...
      </span>
    );
  }

  if (status === "saved") {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
        <Check size={12} />
        Saved in this browser
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500">
      Unsaved
    </span>
  );
}
